import React from 'react';
import Popper, { PopperPlacementType } from '@material-ui/core/Popper';
import { Fade } from '@material-ui/core';
import style from './styles.module.scss';

const AloPopper = ({
  isOpen,
  anchorEl,
  text,
  placement = 'top-start',
  container = document.body,
  styles,
}: {
  isOpen: boolean;
  anchorEl: Element;
  text: string;
  container?: Element | null;
  placement: PopperPlacementType;
  styles?: React.CSSProperties;
}) => {
  const isFirstSwatch = placement === 'top-start';

  return (
    <>
      <Popper
        open={isOpen}
        anchorEl={anchorEl}
        placement={placement}
        style={styles}
        transition
        disablePortal={false}
        container={container}
        modifiers={{
          flip: {
            enabled: false,
          },
          offset: {
            enabled: true,
            offset: '0 10px',
          },
          preventOverflow: {
            escapeWithReference: true,
          },
        }}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <div className={isFirstSwatch ? style.paper : `${style.paper} ${style.paperSwatch}`}>
              <p className={'popper-text tag-small uppercase'}>{text}</p>
            </div>
          </Fade>
        )}
      </Popper>
    </>
  );
};
export default AloPopper;
